export const MonitoringEndPoint = '/webinterfaces/integrated/public/log_data.aspx';
export const CobrowseAuthEndPoint = '/cobrowse/auth';
export const CobrowseSessionEndPoint = '/cobrowse/session';
export const CobrowseJoinEndPoint = '/cobrowse/session/join';
export const CobrowseACBShellEndPoint = '/cobrowse/acb';
